import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PropTypes } from 'prop-types';
import AccountSelectionList from './AccountSelectionList';

const AccountsIndex = ({ onAccountSelect }) => (
  <div className="p-grid">
    <div className="p-col-12">
      <div className="wrapper brand-detailed-wrapper">
        <div className="p-grid p-fluid">
          <div className="p-col-12">
            <FormattedMessage
              id="msg.select_account"
              defaultMessage="Please select the account you wish to log in to"
            />
          </div>
          <AccountSelectionList onAccountSelect={onAccountSelect} />
        </div>
      </div>
    </div>
  </div>
);

AccountsIndex.propTypes = {
  onAccountSelect: PropTypes.func.isRequired,
};

export default AccountsIndex;
